import type { ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { tokens } from '../../theme/tokens';

export type AppCardVariant = 'default' | 'muted' | 'emphasis' | 'outline';
type AppCardDensity = 'regular' | 'compact';

type AppCardProps = {
  children: ReactNode;
  variant?: AppCardVariant;
  density?: AppCardDensity;
  style?: StyleProp<ViewStyle>;
};

export function AppCard({
  children,
  variant = 'default',
  density = 'regular',
  style,
}: AppCardProps) {
  return <View style={[styles.card, styles[variant], styles[density], style]}>{children}</View>;
}

const styles = StyleSheet.create({
  card: {
    borderRadius: tokens.component.card.radius,
    borderWidth: tokens.border.width,
    padding: tokens.component.card.padding,
    ...tokens.shadow.card,
  },
  regular: {
    padding: tokens.component.card.padding,
  },
  compact: {
    borderRadius: tokens.component.card.compactRadius,
    padding: tokens.component.card.compactPadding,
  },
  default: {
    backgroundColor: tokens.colors.surface,
    borderColor: tokens.colors.border,
  },
  muted: {
    backgroundColor: tokens.colors.surfaceMuted,
    borderColor: tokens.colors.border,
  },
  emphasis: {
    backgroundColor: tokens.colors.primary,
    borderColor: tokens.colors.primary,
  },
  outline: {
    backgroundColor: 'transparent',
    borderColor: tokens.colors.border,
    shadowOpacity: 0,
    elevation: 0,
  },
});
